var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8064_1624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5H15.5C15.5 4.9087 14.8679 3.38258 13.7426 2.25736C12.6174 1.13214 11.0913 0.5 9.5 0.5V6.5Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.5C5.31331 3.5 4.15328 3.85189 3.16658 4.51118C2.17989 5.17047 1.41085 6.10754 0.956726 7.2039C0.5026 8.30026 0.38378 9.50666 0.615291 10.6705C0.846802 11.8344 1.41825 12.9035 2.25736 13.7426C3.09648 14.5818 4.16558 15.1532 5.32946 15.3847C6.49335 15.6162 7.69975 15.4974 8.7961 15.0433C9.89246 14.5892 10.8295 13.8201 11.4888 12.8334C12.1481 11.8467 12.5 10.6867 12.5 9.5H6.5V3.5Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8064_1624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/PieChart.5a1b9514e2d8ebfcd20d8dce68691dec.svg";
export { ForwardRef as ReactComponent };